import React, { useState } from 'react';
import Modal from '../../components/Modal';
import { ModalDirectionOptions } from '../../components/Modal';
import RoscCheckListDialog from '../RoscCheckListDialog';
import { useTranslation } from 'react-i18next';

interface CprManagerActionSectionProps {
  showDeathMessage: boolean;
  showSuccessMessage: boolean;
  deathTime: number | null;
  successTime: number | null;
  showDeathModal: boolean;
  showROSCModal: boolean;
  onROSCClick: () => void;
  onDeathClick: () => void;
  onConfirmROSC: () => void;
  onConfirmDeath: () => void;  
  onCloseDeathModal: () => void;
  onCloseROSCModal: () => void;
}

export const CprManagerActionSection: React.FC<CprManagerActionSectionProps> = ({  
  showDeathMessage,
  showSuccessMessage,
  deathTime,
  successTime,
  showDeathModal,
  showROSCModal,
  onROSCClick,
  onDeathClick,
  onConfirmROSC,
  onConfirmDeath,
  onCloseDeathModal,
  onCloseROSCModal,
}) => {
  const { t } = useTranslation(['resus']);
  const [isChecklistOpen, setIsChecklistOpen] = useState(false);
  
  const formatTime = (time: number | null) => {
    if (!time) return '';
    return new Date(time).toLocaleTimeString('he-IL', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="actions-section">
      { showDeathMessage ? (
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontWeight: 'bold'
          }}>
            {t('cprManager.patientDeathAtTime', { time: formatTime(deathTime) })}
            <br />
            {t('cprManager.rememberEcgPocus')}
          </div>
        </div>
      ) : showSuccessMessage ? (
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontWeight: 'bold',
          }}>
            {t('cprManager.cprSuccessAtTime', { time: formatTime(successTime) })}
            <br />
            <a style={{cursor: 'pointer', color: '#1FB5A3'}}
              onClick={() => setIsChecklistOpen(true)}
              className="text-blue-600 hover:text-blue-800 underline"
            >
              {t('cprManager.roscChecklistLink')}
            </a>
          </div>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          direction: 'rtl'
        }}>
          <button 
            data-testid="cpr-manager-action-section-rosc-button"
            className="btn-reset rosc-button" onClick={onROSCClick}>
            ROSC
          </button>
          <button 
            data-testid="cpr-manager-action-section-death-button"
            className="red-button death-button" onClick={onDeathClick}>
            DEATH
          </button>
        </div>
      )}

      {/* Modals */}
      <Modal
        isOpen={showDeathModal}
        setIsOpen={onCloseDeathModal}
        title={t('cprManager.confirmDeathTitle')}
        secondaryButton={{
          text: t('buttons.cancel'),
          onClick: onCloseDeathModal,
        }}
        primaryButton={{
          text: t('buttons.confirm'),
          onClick: onConfirmDeath,
        }}
        direction={ModalDirectionOptions.RTL}
      >
        <p>{t('cprManager.confirmDeathMessage')}</p>
      </Modal>

      <Modal
        isOpen={showROSCModal}
        setIsOpen={onCloseROSCModal}
        title={t('cprManager.endCprTitle')}
        secondaryButton={{
          text: t('buttons.cancel'),
          onClick: onCloseROSCModal,
        }}
        primaryButton={{
          text: t('buttons.confirm'),
          onClick: onConfirmROSC,
        }}
        direction={ModalDirectionOptions.RTL}
      >
        <p>{t('cprManager.confirmEndCprMessage')}</p>
      </Modal>

      {/* ROSC Checklist Dialog */}
      <RoscCheckListDialog 
        isOpen={isChecklistOpen}
        setIsOpen={setIsChecklistOpen}
      />
    </div>
  );
};
